import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/services/users/authentication.service';
@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authenticationService.getCurrentToken().then((token) => {
      if (token && token.length > 1) {
        this.router.navigate(['/dashboard']);
        return false;
      } else {
        return true;
      }
    });
  }
}
